export default __webpack_public_path__ + "static/media/unique.c4718c2b.svg";